import { render, staticRenderFns } from "./ProductSettings.vue?vue&type=template&id=25e2e1b0&scoped=true&"
import script from "./ProductSettings.vue?vue&type=script&lang=js&"
export * from "./ProductSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProductSettings.vue?vue&type=style&index=0&id=25e2e1b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e2e1b0",
  null
  
)

export default component.exports